/* ============================================================
   LITTLE DUMPLING — Theme JavaScript
   ============================================================ */

(function() {
  'use strict';

  // ── Cart Drawer ──────────────────────────────────────────
  const CartDrawer = {
    drawer: null,
    overlay: null,
    countEl: null,

    init() {
      this.drawer = document.getElementById('ld-cart-drawer');
      this.overlay = document.getElementById('ld-cart-overlay');
      this.countEl = document.querySelector('.ld-nav__cart-count');

      document.querySelectorAll('[data-open-cart]').forEach(btn => {
        btn.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      document.querySelectorAll('[data-close-cart]').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      // Sync cart count from Shopify
      this.fetchCount();
    },

    open() {
      if (!this.drawer) { window.location.href = '/cart'; return; }
      this.fetchCart();
      this.drawer.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      if (this.drawer) this.drawer.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    },

    async fetchCount() {
      try {
        const res = await fetch('/cart.js');
        const data = await res.json();
        this.updateCount(data.item_count);
      } catch(e) {}
    },

    async fetchCart() {
      try {
        const res = await fetch('/cart.js');
        const data = await res.json();
        this.renderCart(data);
        this.updateCount(data.item_count);
      } catch(e) {}
    },

    updateCount(count) {
      if (this.countEl) {
        this.countEl.textContent = count;
        this.countEl.style.display = count > 0 ? 'flex' : 'none';
      }
    },

    renderCart(cart) {
      const body = document.querySelector('.ld-cart-drawer__body');
      const footer = document.querySelector('.ld-cart-drawer__footer');
      if (!body) return;

      if (cart.items.length === 0) {
        body.innerHTML = `
          <div class="ld-cart-drawer__empty">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="30" stroke="var(--ld-border-str)" stroke-width="2"/>
              <path d="M20 20H24L30 42H46L50 28H24" stroke="var(--ld-brown-lt)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="32" cy="48" r="2" fill="var(--ld-brown-lt)"/>
              <circle cx="44" cy="48" r="2" fill="var(--ld-brown-lt)"/>
            </svg>
            <p>Your cart is empty</p>
            <a href="/collections/all" class="ld-btn ld-btn--green" onclick="CartDrawer.close()">Start shopping →</a>
          </div>`;
        if (footer) footer.style.display = 'none';
        return;
      }

      if (footer) footer.style.display = 'block';
      body.innerHTML = cart.items.map(item => `
        <div class="ld-cart-item" data-key="${item.key}">
          <div class="ld-cart-item__img">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="ld-cart-item__info">
            <div class="ld-cart-item__vendor">${item.vendor}</div>
            <div class="ld-cart-item__title">${item.product_title}</div>
            <div class="ld-cart-item__price">${this.formatMoney(item.final_price)}</div>
            <div class="ld-cart-item__qty">
              <button onclick="CartDrawer.updateItem('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button onclick="CartDrawer.updateItem('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
              <button onclick="CartDrawer.updateItem('${item.key}', 0)" style="margin-left:8px;font-size:11px;color:var(--ld-brown-lt);width:auto;border-radius:4px;padding:0 6px;" aria-label="Remove">Remove</button>
            </div>
          </div>
        </div>`).join('');

      const subtotalEl = document.querySelector('.ld-cart-drawer__subtotal span:last-child');
      if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
    },

    async updateItem(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const data = await res.json();
        this.renderCart(data);
        this.updateCount(data.item_count);
      } catch(e) {}
    },

    formatMoney(cents) {
      return '₱' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  // ── Add to Cart ──────────────────────────────────────────
  async function addToCart(variantId, quantity = 1) {
    const btn = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      await res.json();
      if (btn) { btn.textContent = 'Added! ♥'; setTimeout(() => { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2000); }
      CartDrawer.open();
    } catch(e) {
      if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
    }
  }

  // ── Mobile Nav ───────────────────────────────────────────
  function initMobileNav() {
    const toggle = document.querySelector('.ld-nav__mobile-toggle');
    const menu = document.querySelector('.ld-nav__mobile-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', menu.classList.contains('open'));
    });
  }

  // ── Impact Counters ──────────────────────────────────────
  function initCounters() {
    const cards = document.querySelectorAll('[data-count-target]');
    if (!cards.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseInt(el.dataset.countTarget, 10);
        let cur = 0;
        const step = Math.ceil(target / 72);
        const t = setInterval(() => {
          cur = Math.min(cur + step, target);
          el.textContent = cur.toLocaleString();
          if (cur >= target) clearInterval(t);
        }, 20);
        io.unobserve(el);
      });
    }, { threshold: 0.3 });

    cards.forEach(el => io.observe(el));
  }

  // ── FAQ ──────────────────────────────────────────────────
  function initFaq() {
    document.querySelectorAll('.ld-faq-q').forEach(q => {
      q.addEventListener('click', () => {
        const item = q.closest('.ld-faq-item');
        const answer = item.querySelector('.ld-faq-a');
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.ld-faq-item').forEach(i => {
          i.classList.remove('open');
          i.querySelector('.ld-faq-a').classList.remove('open');
        });
        if (!isOpen) { item.classList.add('open'); answer.classList.add('open'); }
      });
    });
  }

  // ── Product Gallery ──────────────────────────────────────
  function initGallery() {
    const thumbs = document.querySelectorAll('.ld-product-gallery__thumb');
    const main = document.querySelector('.ld-product-gallery__main img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        main.src = thumb.querySelector('img').src.replace('_100x', '_800x');
      });
    });
  }

  // ── Filter Sidebar (collection) ──────────────────────────
  function initFilters() {
    const filterForm = document.querySelector('.ld-filter-form');
    if (!filterForm) return;
    filterForm.addEventListener('change', () => {
      // In production: Shopify's URL-based filtering handles this
      // For theme preview, update the count display
      const resultCount = document.querySelector('.ld-result-count');
      if (resultCount) {
        // Shopify will handle actual filtering via URL params
      }
    });
  }

  // ── Newsletter ───────────────────────────────────────────
  function initNewsletter() {
    document.querySelectorAll('.ld-newsletter-form').forEach(form => {
      form.addEventListener('submit', (e) => {
        // Shopify handles newsletter form submission natively
        // This provides visual feedback
        const btn = form.querySelector('button[type="submit"]');
        const input = form.querySelector('input[type="email"]');
        if (!input.value.includes('@')) {
          e.preventDefault();
          input.style.borderColor = 'var(--ld-blush)';
          setTimeout(() => { input.style.borderColor = ''; }, 1500);
          return;
        }
        if (btn) {
          btn.textContent = 'Thank you! ♥';
          btn.style.background = 'var(--ld-meadow)';
          btn.style.color = '#fff';
        }
      });
    });
  }

  // ── Variant Selector ─────────────────────────────────────
  function initVariantSelector() {
    const selector = document.querySelector('.ld-variant-select');
    if (!selector) return;
    selector.addEventListener('change', (e) => {
      const btn = document.querySelector('.ld-product-info__add');
      if (btn) btn.dataset.variantId = e.target.value;
    });
  }

  // ── Product Add To Cart ──────────────────────────────────
  function initProductPage() {
    const addBtn = document.querySelector('.ld-product-info__add');
    if (!addBtn) return;
    addBtn.addEventListener('click', () => {
      const variantId = addBtn.dataset.variantId;
      if (variantId) addToCart(variantId);
    });
  }

  // ── Announcement Dismiss ──────────────────────────────────
  function initAnnouncement() {
    const closeBtn = document.querySelector('.ld-announce__close');
    if (!closeBtn) return;
    closeBtn.addEventListener('click', () => {
      document.querySelector('.ld-announce').remove();
    });
  }

  // ── Init ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    initMobileNav();
    initCounters();
    initFaq();
    initGallery();
    initFilters();
    initNewsletter();
    initVariantSelector();
    initProductPage();
    initAnnouncement();
  });

  // Expose globally for inline event handlers
  window.CartDrawer = CartDrawer;
  window.addToCart = addToCart;

})();
